import React from "react";
import styles from "./Thankyou.module.css";
import Button from "../../component/Button";
import { useNavigate } from "react-router-dom";
import SecondImage from "../../assets/images/ThankYou.png";
import ButtonOld from "../../component/ButtonOld";

const Thankyou = () => {
  const navigate = useNavigate();

  const onButtonClick = () => {
    if (true) {
      navigate("/");
    }
  };

  return (
    <>
      <div className='container'>
        <div className={styles.mainWrapper}>
          <div className={styles.thankYouHeading}>
            <p>Thank You!</p>
          </div>
          <img
            src={SecondImage}
            className={styles.thankYouImage}
            alt='raised hand'
          />
          <div>
            <p className={styles.feedbackText}>
              Your participation is helping to make our country cleaner and
              better.
            </p>
          </div>
        </div>
        <div className={styles.bottomButtonWrapper}>
          <ButtonOld text='Close' onClick={onButtonClick} disabled={false} />
        </div>
      </div>
    </>
  );
};

export default Thankyou;
